import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackEmotionRatingListing from "../EmotionRating/FeedbackEmotionRatingListing";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question9FlashCoachExperience = ({
  accessibilityRating,
  updateEmotionRatingFormData,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "Was the accessibility and loading speed of the platform satisfactory?"
          }
        />
        <FeedbackEmotionRatingListing
          inputID={"accessibilityRating"}
          emotionRatingList={accessibilityRating}
          updateEmotionRatingFormData={updateEmotionRatingFormData}
        />
      </FeedbackFormLayout>
    </>
  );
};
